import { keyBy } from 'lodash-unified';
import { GameId } from '@bg-shared/enums/GameId';
import { BettingOptionsFormat, formatBettingOption } from '@betgames/bg-tools';
import {
    IWebSocketsBettingOption,
    IFormattedBettingOptions,
} from '@bg-shared/interfaces/IBettingOption';

interface IParams {
    gameId: GameId;
    format: BettingOptionsFormat;
    options: IWebSocketsBettingOption[];
}

export const mapWebSocketsBettingOptions = (params: IParams): IFormattedBettingOptions =>
    keyBy(
        params.options.map((odd) => ({
            gameId: params.gameId,
            id: odd.id,
            value: odd.value,
            formattedValue: formatBettingOption({
                value: odd.value,
                format: params.format,
            }),
            status: odd.status,
        })),
        'id',
    );
